import { createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/img/qz_btn.png'
import _imports_1 from '../assets/img/bz_btn.png'
import _imports_2 from '../assets/img/intro.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: "https://yunyingcdn.thecover.cn/au_5fc6f0241061d79c680672e3/20220909/1FF7514C-A0C3-8B44-6700-F14A7A23DDC3.jpg",
  class: "banner",
  alt: ""
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "qbz-btn" }, [
  /*#__PURE__*/_createVNode("a", { href: "https://h5.thepage.cn/apply/#/?id=63159edeacf5c200598836d7" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_0,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createVNode("a", { href: "https://h5.thepage.cn/apply/#/?id=6316093ddc77ba0034c7f263" }, [
    /*#__PURE__*/_createVNode("img", {
      src: _imports_1,
      alt: ""
    })
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "intro",
  alt: ""
}, null, -1)
const _hoisted_5 = { class: "title" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "title-name" }, [
  /*#__PURE__*/_createVNode("div", { class: "title-br" }),
  /*#__PURE__*/_createVNode("span", null, "云求助")
], -1)
const _hoisted_7 = { class: "title" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "title-name" }, [
  /*#__PURE__*/_createVNode("div", { class: "title-br" }),
  /*#__PURE__*/_createVNode("span", null, "地震快报")
], -1)
const _hoisted_9 = { class: "title" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "title-name" }, [
  /*#__PURE__*/_createVNode("div", { class: "title-br" }),
  /*#__PURE__*/_createVNode("span", null, "应急救援")
], -1)
const _hoisted_11 = { class: "title" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "title-name" }, [
  /*#__PURE__*/_createVNode("div", { class: "title-br" }),
  /*#__PURE__*/_createVNode("span", null, "现场直击")
], -1)
const _hoisted_13 = { class: "title" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "title-name" }, [
  /*#__PURE__*/_createVNode("div", { class: "title-br" }),
  /*#__PURE__*/_createVNode("span", null, "交通路况")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_News = _resolveComponent("News")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _withDirectives(_createVNode("div", _hoisted_5, [
      _hoisted_6,
      _createVNode("a", {
        href: _ctx.cateLink(7422),
        class: "title-more"
      }, "查看更多 >", 8, ["href"])
    ], 512), [
      [_vShow, _ctx.qz.length]
    ]),
    _createVNode(_component_News, { data: _ctx.qz }, null, 8, ["data"]),
    _withDirectives(_createVNode("div", _hoisted_7, [
      _hoisted_8,
      _createVNode("a", {
        href: _ctx.cateLink(7411),
        class: "title-more"
      }, "查看更多 >", 8, ["href"])
    ], 512), [
      [_vShow, _ctx.kb.length]
    ]),
    _createVNode(_component_News, { data: _ctx.kb }, null, 8, ["data"]),
    _withDirectives(_createVNode("div", _hoisted_9, [
      _hoisted_10,
      _createVNode("a", {
        href: _ctx.cateLink(7412),
        class: "title-more"
      }, "查看更多 >", 8, ["href"])
    ], 512), [
      [_vShow, _ctx.jy.length]
    ]),
    _createVNode(_component_News, { data: _ctx.jy }, null, 8, ["data"]),
    _withDirectives(_createVNode("div", _hoisted_11, [
      _hoisted_12,
      _createVNode("a", {
        href: _ctx.cateLink(7415),
        class: "title-more"
      }, "查看更多 >", 8, ["href"])
    ], 512), [
      [_vShow, _ctx.zj.length]
    ]),
    _createVNode(_component_News, { data: _ctx.zj }, null, 8, ["data"]),
    _withDirectives(_createVNode("div", _hoisted_13, [
      _hoisted_14,
      _createVNode("a", {
        href: _ctx.cateLink(7413),
        class: "title-more"
      }, "查看更多 >", 8, ["href"])
    ], 512), [
      [_vShow, _ctx.lk.length]
    ]),
    _createVNode(_component_News, { data: _ctx.lk }, null, 8, ["data"])
  ]))
}